import React from 'react';
import TwitterIcon from '../img/social/twitter'
import EmailIcon from '../img/social/email'
import CallUsIcon from '../img/social/call'
import FbIcon from '../img/social/fb'
import InIcon from '../img/social/in'

const SocialButton = (props) => {

  const { icon, url } = props

  let Icon;
  switch (icon) {
    case 'email':
      Icon = EmailIcon;
      break;
    case 'call':
      Icon = CallUsIcon;
      break;
    case 'fb':
      Icon = FbIcon;
      break;
    case 'twitter':
      Icon = TwitterIcon;
      break;
    case 'in':
      Icon = InIcon;
      break;
    default:
      Icon = ''
  }
  
  return (
    <a href={url} className="footer_sq text-white d-block bg-primary d-flex justify-content-center">
      <Icon/>
    </a>
  )
}

export default SocialButton